import { createSlice } from "@reduxjs/toolkit";
import { productPropGetAll } from "./productPropAsyncThunk";

const productPropGetAllSlice = createSlice({
  name: "productProp",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productPropGetAll.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productPropGetAll.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [productPropGetAll.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productPropGetAllSlice.reducer;
